<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t8">By</span> R<span class="t9">USSELL</span> J. S<span class="t9">ANDERS</span></p>
<p class="p0"><span class="t8">The Book of Ethan</span></p>
<p class="p0"><span class="t8">Colors</span></p>
<p class="p0"><span class="t8">Special Effect</span></p>
<p class="p7"><span class="t8">Published by</span> H<span class="t9">ARMONY</span> I<span class="t9">NK</span> P<span class="t9">RESS</span></p>
<p class="p0"><span class="t8">http://www.harmonyinkpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?56466ee7